const DEFAULT_FORM_COLOR = "#3b82f6";

const TAILWIND_TO_HEX: Record<string, { bg: string; border: string }> = {
	"slate-50": { bg: "#f8fafc", border: "#94a3b8" }, "gray-50": { bg: "#f9fafb", border: "#9ca3af" },
	"zinc-50": { bg: "#fafafa", border: "#a1a1aa" }, "neutral-50": { bg: "#fafafa", border: "#a3a3a3" },
	"stone-50": { bg: "#fafaf9", border: "#a8a29e" }, "red-50": { bg: "#fef2f2", border: "#f87171" },
	"orange-50": { bg: "#fff7ed", border: "#fb923c" }, "amber-50": { bg: "#fffbeb", border: "#fbbf24" },
	"yellow-50": { bg: "#fefce8", border: "#facc15" }, "lime-50": { bg: "#f7fee7", border: "#a3e635" },
	"green-50": { bg: "#f0fdf4", border: "#4ade80" }, "emerald-50": { bg: "#ecfdf5", border: "#34d399" },
	"teal-50": { bg: "#f0fdfa", border: "#2dd4bf" }, "cyan-50": { bg: "#ecfeff", border: "#22d3ee" },
	"sky-50": { bg: "#f0f9ff", border: "#38bdf8" }, "blue-50": { bg: "#eff6ff", border: "#60a5fa" },
	"indigo-50": { bg: "#eef2ff", border: "#818cf8" }, "violet-50": { bg: "#f5f3ff", border: "#a78bfa" },
	"purple-50": { bg: "#faf5ff", border: "#c084fc" }, "fuchsia-50": { bg: "#fdf4ff", border: "#e879f9" },
	"pink-50": { bg: "#fdf2f8", border: "#f472b6" }, "rose-50": { bg: "#fff1f3", border: "#fb7185" },
};

export function resolveFormColor(color: string | null | undefined): { bg: string; border?: string } {
	if (!color) return { bg: DEFAULT_FORM_COLOR };
	const mapped = TAILWIND_TO_HEX[color];
	if (mapped) return mapped;
	return { bg: color.startsWith("#") ? color : DEFAULT_FORM_COLOR };
}

export function contrastText(hex: string): string {
	const c = hex.replace("#", "");
	const r = parseInt(c.substring(0, 2), 16);
	const g = parseInt(c.substring(2, 4), 16);
	const b = parseInt(c.substring(4, 6), 16);
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
	return luminance > 0.6 ? "#1a1a1a" : "#ffffff";
}
